// src/pages/Login/Login.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, user, loading: authLoading } = useAuth(); // Get user and loading from auth context
  const navigate = useNavigate();

  // Check if user is already authenticated
  useEffect(() => {
    // If user is already logged in, redirect to dashboard
    if (!authLoading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(username, password);
    setLoading(false);
    if (success) {
      navigate('/dashboard', { replace: true }); // Use replace to prevent back button to login
    }
  };

  // Show loading while checking authentication
  if (authLoading) {
    return (
      <section className="admin-login-page">
        <div className="login-box">
          <div className="row">
            <div className="col-12 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // If user is authenticated, don't render login form
  if (user) {
    return null;
  }

  return (
    <section className="admin-login-page">
      <div className="login-box">
        <div className="row">
          <div className="col-12 mb-3">
            <img src="/img/admin-logo.png" alt="" className="img-fluid" />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="input-box mb-3 col-12">
              <label>User Name</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control input-login"
                placeholder="USER NAME"
                required
              />
            </div>
            <div className="input-box mb-3 col-12">
              <label>Password</label>
              <div className="password-input">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control input-login"
                  placeholder="ENTER PASSWORD"
                  required
                />
                <img
                  src={showPassword ? "/img/eye-open.png" : "/img/eye-close.png"}
                  alt=""
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
            <div className="mb-3 col-12">
              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;